export class NpiDialogDto {
  // tslint:disable-next-line:variable-name
  first_name: string;
  // tslint:disable-next-line:variable-name
  last_name: string;
  city: string;
  number: string;
  // tslint:disable-next-line:variable-name
  postal_code: string;
  state: string;
}
